// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"photoGreeting-module--MainContainer--3CQAZ","BackgroundImage":"photoGreeting-module--BackgroundImage--2C6pJ","Content":"photoGreeting-module--Content--28Weu"};